import React from "react";
import { useTranslation } from "react-i18next";

const AppleStoreImage = require("../../assets/images/Apple-Store.png");
const GooglePlayImage = require("../../assets/images/Google-Play.png");

const APP_WIZEWINGS_APPLE =
  "https://apps.apple.com/us/app/wizewings/id1637461718";
const APP_WIZEWINGS_GOOGLE =
  "https://play.google.com/store/apps/details?id=aero.wizewings.wizewings";

export function DownloadAppSection() {
  const { t } = useTranslation();

  return (
    <section className="download-app-section">
      <h2>{t("downloadOurApp")}</h2>

      <div className="download-app-buttons">
        <a
          href={APP_WIZEWINGS_APPLE}
          target="_blank"
          rel="noopener noreferrer"
          className="download-app-button"
          aria-label={t("downloadOnAppleStore")}
        >
          <img src={AppleStoreImage} alt={t("downloadOnAppleStore")} />
        </a>

        <a
          href={APP_WIZEWINGS_GOOGLE}
          target="_blank"
          rel="noopener noreferrer"
          className="download-app-button"
          aria-label={t("downloadOnGooglePlay")}
        >
          <img src={GooglePlayImage} alt={t("downloadOnGooglePlay")} />
        </a>
      </div>
    </section>
  );
}
